<dx-data-grid
	id="tasks-grid"
	class="theme-dependent"
	height="100%"
	[dataSource]="workRequests"
	(onRowClick)="navigateToDetails($event)"
	(onEditingStart)="toogleUseNavigation()"
	(onEditCanceled)="toogleUseNavigation()"
	(onSaved)="toogleUseNavigation()"
	[hoverStateEnabled]="true"
	[columnAutoWidth]="true"
	[showBorders]="true"

>
	<dxo-paging [pageSize]="15"></dxo-paging>
	<dxo-pager [visible]="true" [showPageSizeSelector]="true"></dxo-pager>
	<!-- <dxo-editing mode="row" [allowUpdating]="true"></dxo-editing> -->
	<!-- <dxo-selection
		selectAllMode="allPages"
		showCheckBoxesMode="always"
		mode="multiple"
	></dxo-selection> -->
	<dxo-scrolling mode="virtual"></dxo-scrolling>
	<dxo-sorting mode="multiple"></dxo-sorting>
	<dxo-header-filter [visible]="true"></dxo-header-filter>

	<dxi-column 
		dataField="customerName" 
		caption="Partner" 
		[hidingPriority]="5">
		<dxi-validation-rule type="required"></dxi-validation-rule>
	</dxi-column>
	<dxi-column
		dataField="status"
		caption="Állapot"
		[hidingPriority]="6"
		[minWidth]="120"
		cellTemplate="cellStatus"
		editCellTemplate="editCellStatus"
	>
		<dxo-lookup [dataSource]="statusList"></dxo-lookup>
		<dxi-validation-rule type="required"></dxi-validation-rule>
	</dxi-column>
	<dxi-column 
		dataField="subject" 
		caption="Tárgy" 
		[hidingPriority]="7"
		[minWidth]="240"
	>
		<dxi-validation-rule type="required"></dxi-validation-rule>
	</dxi-column>
	<!-- <dxi-column
		dataField="earliestStartDate"
		caption="Legkorábbi kezdő dátum"
		dataType="date"
		[format]="{ type: 'yyyy-MM-dd' }"
		[hidingPriority]="4"
	>
		<dxi-validation-rule type="required"></dxi-validation-rule>
	</dxi-column> -->
	<!-- <dxi-column
		dataField="latestEndDate"
		caption="Legkésőbbi befejezési dátum"
		dataType="date"
		[format]="{ type: 'yyyy-MM-dd' }"
		[hidingPriority]="3"
	>
		<dxi-validation-rule type="required"></dxi-validation-rule>
	</dxi-column> -->
	<!-- id: number,
	tenantId: number,
	timeStamp: Date,
	customerId: number,
	requestorId: number,
	createdDate: Date,
	description: string,
	statusId: number,
	rejectionReason: string,
	tenantName: string,
	requestorName: string,
-->
	<!-- <dxi-column 
		dataField="preferedWorkerName" 
		caption="Igényelt munkatárs" 
		[hidingPriority]="2">
		<dxi-validation-rule type="required"></dxi-validation-rule>
	</dxi-column> -->

	<dxi-column 
		dataField="createdDate" 
		caption="Bejelentés dátuma" 
		dataType="date"
		[hidingPriority]="1"
		[format]="{ type: 'yyyy-MM-dd' }"
		[sortOrder]="'desc'"
	>
		<dxi-validation-rule type="required"></dxi-validation-rule>
	</dxi-column>

	<div *dxTemplate="let cellInfo of 'cellStatus'">
		<status-indicator
			[isField]="false"
			[value]="cellInfo.data.status"
		></status-indicator>
	</div>

	<div *dxTemplate="let cellInfo of 'editCellStatus'">
		<dx-select-box
			class="edit-cell"
			[(value)]="cellInfo.value"
			[items]="statusList"
			(onValueChanged)="cellInfo.setValue($event.value)"
			(onSelectionChanged)="cellInfo.component.updateDimensions()"
			fieldTemplate="field"
		>
			<div *dxTemplate="let data of 'field'">
				<status-indicator [value]="cellInfo.value"></status-indicator>
			</div>
			<div *dxTemplate="let s of 'item'">
				<status-indicator [isField]="false" [value]="s"></status-indicator>
			</div>
		</dx-select-box>
	</div>
</dx-data-grid>
